export default "__VITE_ASSET__C9b0pHQq__"